import "./styles.css";
import { startApp } from "./ui/app";

startApp(document.getElementById("app")!).catch((e) => {
  console.error(e);
  document.getElementById("app")!.innerHTML = `<div class="shell"><h1>Something went wrong</h1><p class="muted">Reload the page. If it keeps happening, tell Meliesa.</p></div>`;
});
